import React from 'react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import type { FieldConfiguration } from '../../../../types/layout-items.tsx';
import { ApprovalStep } from './approval-step/index.tsx';
import { ApprovalsStepBundle } from './approvals-step-bundle/view.tsx';
import messages from './messages.tsx';
import { getApprovalStepData } from './util.tsx';

export type Props = {
	configuration?: FieldConfiguration;
};

export const ApprovalsData = (props: Props) => {
	const intl = useIntl();
	const { configuration } = props;
	const rawData = configuration ? configuration['jsd.field.approval.all.configs'] : undefined;

	if (rawData === undefined || rawData === null || !Array.isArray(rawData)) {
		return null;
	}

	const steps = rawData.map((rawDataItem: unknown, index) => {
		const approvalStepData = getApprovalStepData(rawDataItem);

		if (approvalStepData == null) {
			return null;
		}

		const { statusId, customFieldName, statusName, defaultApproverIds } = approvalStepData;

		return (
			<ApprovalStep
				key={statusId + index}
				approverListFieldName={customFieldName}
				numberOfApprovers={approvalStepData.numberOfApprovers}
				whoChoosesApprovers={approvalStepData.whoChoosesApprovers}
				approvalStatus={statusName}
				defaultApprovers={defaultApproverIds}
			/>
		);
	});

	return (
		<Box xcss={containerStyles}>
			<ApprovalsStepBundle approvalSteps={steps} />
			<Heading size="xxsmall" as="div">
				{intl.formatMessage(messages.portalNotice)}
			</Heading>
		</Box>
	);
};

const containerStyles = xcss({
	paddingLeft: 'space.500',
	paddingRight: 'space.500',
	marginBottom: 'space.300',
});
